<div class="ccs-container">
  <app-sidebar class="sidebar" (navigate)="onNavigate($event)"></app-sidebar>
  <div class="main-content">
    <app-header class="header"></app-header>
    <app-content class="content" (navigate)="onNavigate($event)"></app-content>
  </div>
</div>
